
import { QuestaoDeSelecao } from '@/dominio/formulario/questoes/selecao/QuestaoDeSelecao';
import { Selecao } from '@/dominio/formulario/questoes/selecao/Selecao';
import { defineComponent } from 'vue';
import SelecaoComponent from './SelecaoComponent.vue';

export default defineComponent({
    name: 'QuestaoSelecoesComponent',
    props: {
        questao: {
            type: QuestaoDeSelecao,
            required: true,
        },
    },
    data() {
        return {
            filtroSelecoes: '',
            estaQuestao: this.questao,
            selecoes: [] as Selecao[],
        };
    },
    components: {
        SelecaoComponent,
    },
    computed: {
        selecaoesFiltradas() {
            return this.estaQuestao.selecoes.filter(selecao => {
                return (selecao as Selecao)
                    .getLabel()
                    .toLowerCase()
                    .includes(this.filtroSelecoes.toLowerCase());
            });
        },
    },
    methods: {
        selecionarValor(selecao: Selecao) {
            this.selecoes.push(selecao);
            this.questao.setValoresSelecionado(this.selecoes);
        },
        deselecionarValor(selecao: Selecao) {
            const indice = this.selecoes.indexOf(selecao);
            this.selecoes.splice(indice, 1);
            this.questao.setValoresSelecionado(this.selecoes);
        },
    },
});
